<template>

    <div> 
        <Header/>

        <div class="py-3">
        <div class="container mx-auto max-w-[1200px] px-6 md:px-0">
            <div class="flex flex-col-reverse lg:flex-row justify-between items-center gap-8 rounded-3xl shadow-xl my-10 h-full">
            <div class="lg:px-20 flex flex-col py-10 gap-6 justify-between h-full text-center lg:text-left px-6">
                <h1 class="font-bold text-xl lg:text-3xl prime">
                Welcome Co-ordinator
                <span class="text-[#105C8E] text-xl lg:text-xl ml-2 lg:ml-5"></span>
                </h1>

                <div class="max-w-sm text-center lg:text-left">
                  <h2 class="font-bold text-2xl lg:text-4xl text-[#1a2b6d] mb-4 leading-tight">
                    Your Growth Journey <br/>
                    <span class="text-blues">Continues Here</span>
                  </h2>
                  <p class="content text-lg">
                    Access your learning resources, complete your assigned trainings, and build new skills — all in one place.
                  </p>
                </div>

                <!-- <form @submit.prevent="searchUserValue" class="w-full">
                <div class="flex flex-wrap md:flex-nowrap items-center justify-center lg:justify-start gap-4">
                    <input type="text" v-model="search_title" @input="searchUserValue" placeholder="Search The Course"
                    class="rounded-full px-6 py-3 border w-full lg:w-auto" />
                    <button type="submit" class="bg-primary py-3 rounded-2xl text-white px-6">
                    Search
                    </button>
                </div>
                </form> -->
            <SearchView />

            </div>

            <div class="flex justify-center lg:justify-end w-full lg:w-auto">
                <img src="@/assets/new/index.jpeg" alt=""
                class="w-full lg:w-auto h-auto rounded-r-3xl object-contain max-h-[400px]" />
            </div>
            </div>
        </div>
        </div>

<div class="py-3 pb-20">
      <div class="container mx-auto max-w-[1200px] px-6 md:px-0">
        <div
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 shadow-xl rounded-3xl p-4"
          style="box-shadow: 0px 2px 20px 0px #105c8e26"
        >
          <!-- calender -->
          <div class="flex flex-col md:min-w-[330px]">
            <!-- <h1 class="text-[#0F172A] text-lg font-semibold px-6 pt-6">Calendar</h1> -->
            <div class="flex flex-col gap-3 md:min-w-[330px]">
              <Calendar @addFilterEmit="receiveCalEmit" />
              <!-- <vue-cal
                small
                ref="vuecal"
                events-on-month-view="short"
                :disable-views="['years', 'year', 'week', 'day']"
                :events="values"
                :on-event-click="onEventClick"
                class=""
              >
              </vue-cal> -->
            </div>
          </div>

          <!-- todo -->
          <div class="flex flex-col gap-3 md:min-w-[330px]">
            <div
              class="bg-[#EDF8FF] flex justify-between py-2 px-3 rounded-xl items-center"
            >
              <h1 class="text-[#0085DB] text-lg font-semibold">
                Tasks for Today
              </h1>
              <router-link :to="{ name: 'CoordinateMyTask' }">
                <img
                  src="@/assets/chevron-down.png"
                  alt=""
                  srcset=""
                  class="object-contain w-5 h-5"
                />
              </router-link>
            </div>
            <div class="flex flex-col gap-2 justify-start p-6 h-[330px]">
              <form @submit.prevent="addTask">
                <div class="flex flex-col gap-2">
                  <p
                    v-if="success_message"
                    class="text-xs text-green-400 font-bold"
                  >
                    {{ success_message }}
                  </p>
                  <p
                    v-if="success_delemessage"
                    class="text-xs text-red-400 font-bold"
                  >
                    {{ success_delemessage }}
                  </p>

                  <div class="">
                    <input
                      v-model="newTask"
                      type="text"
                      class="border-b outline-none flex-1 p-1 w-full"
                      placeholder="+Add New Task"
                      @input="showButton = newTask.length > 0"
                      @keyup.enter="addTask"
                    />
                  </div>
                  <div
                    v-show="showButton"
                    class="flex justify-end items-center"
                  >
                    <div class="flex gap-1">
                      <button
                        class="text-white rounded transition-opacity cursor-pointer"
                      >
                        <!-- ✅ -->
                        <img
                          src="@/assets/newd/Vector(1).svg"
                          alt=""
                          srcset=""
                          class="w-5 h-5 bg-[#EBEBEB] p-1"
                        />
                      </button>
                      <div @click="cleartask" class="cursor-pointer">
                        <img
                          src="@/assets/newd/closebutton.svg"
                          alt=""
                          class="w-6 h-6"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <ul class="overflow-y-auto" v-if="todolist.length > 0">
                <li v-for="task in todolist" :key="task.id" class="group py-2">
                  <div
                    class="flex justify-between bg-[#F4F4F4] w-full p-2 rounded-md"
                    v-if="task.completed == false"
                  >
                    <p class="text-sm break-words w-[230px] line-clamp-2">
                      {{ task.text }}
                    </p>
                    <div
                      class="flex gap-2 w-[25%] opacity-100 xl:opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                    >
                      <!-- <button @click="completeTask(task.id)" class="">✅</button> -->
                      <button @click="completeTask(task.id)" class="">
                        <img
                          src="@/assets/newd/Vector(1).svg"
                          alt=""
                          srcset=""
                          class="w-6 h-6 bg-[#EBEBEB] p-1"
                        />
                      </button>

                      <button @click="openEditPopup(task)" class="">
                        <img
                          src="@/assets/newd/Group.svg"
                          alt=""
                          srcset=""
                          class="w-6 h-6 bg-[#EBEBEB] p-1"
                        />
                      </button>
                      <button @click="deleteTask(task.id)" class="">
                        <img
                          src="@/assets/newd/Vector.svg"
                          alt=""
                          srcset=""
                          class="w-6 h-6 bg-[#EBEBEB] p-1"
                        />
                      </button>
                    </div>
                  </div>
                </li>
              </ul>

              <div v-else class="text-center">No task</div>
              <!-- Edit Popup -->
              <!-- <div
                v-if="isEditing"
                class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
              >
                <div class="bg-white p-4 rounded shadow-lg">
                  <h3 class="mb-2">Edit Task</h3>
                  <input
                    v-model="editTaskText"
                    type="text"
                    class="border p-1 w-full"
                  />
                  <div class="flex justify-end mt-2">
                    <button
                      @click="updateTask"
                      class="bg-blue-500 text-white px-2 py-1 rounded mr-2"
                    >
                      Update
                    </button>
                    <button
                      @click="isEditing = false"
                      class="bg-gray-500 text-white px-2 py-1 rounded"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div> -->
              <div
                v-if="isEditing"
                class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
              >
                <div
                  class="w-[90%] lg:w-[40%] bg-white rounded-xl p-6 lg:p-10 overflow-y-auto max-h-[600px]"
                >
                  <div class="flex items-center justify-center">
                    <h3 class="text-xl font-bold text-textblues text-center">
                      Edit Task
                    </h3>
                  </div>

                  <div
                    class="w-full mt-4 flex flex-col p-6 relative border-gray-100 rounded-2xl"
                  >
                    <div class="w-full">
                      <form
                        ref="createTeamRef"
                        @submit.prevent="updateTask()"
                        class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                      >
                        <div>
                          <textarea
                            v-model="editTaskText"
                            name=""
                            id=""
                            cols="30"
                            rows="5"
                            class="border p-1 w-full"
                          ></textarea>
                        </div>

                        <div class="flex justify-center pb-4 mt-3 gap-10">
                          <button
                            @click="isEditing = false"
                            class="border text-gray-500 rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                          >
                            Close
                          </button>
                          <button
                            class="border text-white rounded-lg bg-blues text-sm px-5 lg:px-10 font-semibold py-2"
                          >
                            Update
                          </button>
                        </div>

                        <div
                          v-if="editmessages"
                          class="text-green-400 text-lg font-bold"
                        >
                          {{ editmessages }}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="" v-for="todo in [0, 1, 2, 3]" :key="todo">
                <div
                  class="flex justify-center gap-4 bg-[#105C8E1A] p-4 rounded-lg items-center"
                >
                  <img
                    src="@/assets/Vector(11).png"
                    alt=""
                    srcset=""
                    class="object contain w-4 h-4 mt-1"
                  />
                  <div class="flex flex-col gap-1">
                    <p class="text-sm font-bold text-[#333333] text-wrap">
                      15 Assignments Due
                    </p>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

          <!-- Announcements -->
          <div class="flex flex-col gap-3 md:min-w-[330px]">
            <div
              class="bg-[#EDF8FF] flex justify-between py-2 px-3 rounded-xl items-center"
            >
              <h1 class="text-[#0085DB] text-lg font-semibold">
                Announcements
              </h1>
              <router-link
                :to="{ name: 'StudentNotifications' }"
                v-if="this.notificationList.length > 3"
              >
                <img
                  src="@/assets/chevron-down.png"
                  alt=""
                  srcset=""
                  class="object-contain w-5 h-5"
                />
              </router-link>
            </div>
            <div class="p-6 w-full h-[330px]">
              <div
                v-if="notificationList.length > 0"
                class="flex flex-col gap-5 lg:justify-between"
              >
                <div
                  class="border-b pb-4 border-gray-300"
                  v-for="notifi in this.notificationList.slice(0, 3)"
                  :key="notifi"
                >
                  <div class="flex gap-4">
                    <img
                      src="@/assets/Group 610.png"
                      alt=""
                      srcset=""
                      class="object contain w-7 h-7 mt-1"
                    />
                    <div class="flex flex-col gap-1">
                      <h1
                        class="text-sm font-bold text-black w-[230px] text-wrap line-clamp-2"
                      >
                        {{ notifi.topic }}
                      </h1>
                      <p
                        class="text-xs font-bold text-[#ADADAD] text-wrap line-clamp-2"
                      >
                        {{ notifi.message }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>No Announcement</div>
            </div>
          </div>
        </div>
      </div>
    </div>
        <Footer/>

    </div>
    

</template>

<script> 

import Header from "@/components/Coordinate/Header.vue";
import Footer from "@/components/Footer.vue";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";
import axios from "axios";
import Calendar from "@/components/Calendar.vue";
import { mapGetters } from "vuex";
import SearchView from "@/components/SearchView.vue";

export default {
     data(){
    return{
       logotitle: process.env.VUE_APP_TITLE,
       notificationList: [],
      todolist: [],
      newTask: "",
      isEditing: false,
      editTaskText: "",
      editTaskId: null,
      showButton: false,
      editmessages: "",
      success_message: "",
      success_delemessage: "",
      currentYear: "",
      currentMonth: "",
      currentDate: "",
      fullDate: "",
    }
  },
    components: {
        Header,
        Footer,
         VueCal,
    Calendar,
    SearchView,
    },
      computed: mapGetters(["userInfo"]),
      async created() {
  
  },
  mounted() {
    this.getNotifications();
    this.getTodo();
   
  },
  methods: {
    receiveCalEmit(data) {
      axios
        .get(
          `${process.env.VUE_APP_API}/to-do-get/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}&date=${data}`
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.todolist = response.data.data.data;
          }
        });

      axios
        .get(
          `${process.env.VUE_APP_API}/notifications/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}&date=${data}`
        )
        .then((response) => {
          if (response) {
            this.notificationList = response.data.data.data;
          }
        });

    },

    cleartask() {
      this.newTask = "";
      this.showButton = false;
    },

    async getNotifications() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/notifications/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}&year=${this.currentYear}&month=${this.currentMonth}&date=${this.fullDate}`
        )
        .then((response) => {
          if (response) {
            this.notificationList = response.data.data.data;
          }
        });
    },
    openEditPopup(task) {
      this.editTaskText = task.text;
      this.editTaskId = task.id;
      this.isEditing = true;
    },
    addTask() {
      if (this.newTask.trim()) {
        let bodyVal = {
          text: this.newTask,
          user: this.userInfo.user.id,
        };

        axios
          .post(
            `${process.env.VUE_APP_API}/to-do-create/?Key=${this.userInfo.token_key}`,
            bodyVal
          )
          .then((response) => {
            if (response.data.status == 200) {
              this.success_message = response.data.message;
              setTimeout(() => {
                this.success_message = "";
              }, 900);
              this.newTask = "";
              this.showButton = false;
              this.getTodo();
            }
          })
          .finally(() => {
            this.loaders = false;
          });
      }
    },
    async getTodo() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/to-do-get/${this.userInfo.user.id}/?Key=${this.userInfo.token_key}&search=false`
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.todolist = response.data.data.data;
          }
        });
    },
    updateTask() {
      let formdata = {
        text: this.editTaskText,
      };

      axios
        .put(
          `${process.env.VUE_APP_API}/to-do-text-edit/${this.editTaskId}/?Key=${this.userInfo.token_key}`,
          formdata
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.editmessages = response.data.message;

            setTimeout(() => {
              this.editmessages = "";
              this.isEditing = false;
              this.getTodo();
            }, 2000);
          }
        })
        .finally(() => {
          this.loaders = false;
        });
    },
    deleteTask(id) {
      axios
        .delete(
          `${process.env.VUE_APP_API}/to-do-update/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.success_delemessage = response.data.message;
            setTimeout(() => {
              this.success_delemessage = "";
            }, 900);
            this.getTodo();
          }
        });
    },
    completeTask(id) {
      let completedata = {
        completed: true,
      };
      axios
        .put(
          `${process.env.VUE_APP_API}/to-do-update/${id}/?Key=${this.userInfo.token_key}`,
          completedata
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.success_message = response.data.message;
            setTimeout(() => {
              this.success_message = "";
            }, 900);
            this.getTodo();
          }
        });
    },
  },
}

</script>

<style> 

</style>